import React, { useState, useEffect } from "react";
import { IoClose, IoEye } from "react-icons/io5";
import { Modal } from "react-bootstrap";
import Button from 'react-bootstrap/Button';
import { deletebuildsheetdata, getsinglebuilsheet, updatebuildsheetdata } from "../../Api/buildsheetApi"
import { getCurrentUser } from "../../Api/auth";
import DriverWood from "./DriverWood";
import Hybrid from "./Hybrid";
import IronWedge from "./IronWedge";
import Wedge from "./Wedge";
import Putter from "./Putter";
import { getInventoryByTypeWithShaftAndGrip } from "../../Api/inventoryApi";

const updateNestedState = (state, path, value) => {
    const keys = path.split('.');
    const lastKey = keys.pop();
    const nestedState = { ...state };

    let current = nestedState;
    keys.forEach(key => {
        if (!current[key]) {
            current[key] = {};
        }
        current = current[key];
    });

    current[lastKey] = value;
    return nestedState;
};

function BuildAccordion({ buildsheets, ondeleteChange, selectedOptions, allmodels, editstatus, remortFittingFormData }) {


    const [show2, setShow2] = useState(false);

    const handleClose2 = () => setShow2(false);
    const handleShow2 = () => setShow2(true);

    const [show3, setShow3] = useState(false);

    const handleClose3 = () => setShow3(false);
    const handleShow3 = () => setShow3(true);

    const [show4, setShow4] = useState(false);

    const handleClose4 = () => setShow4(false);
    const handleShow4 = () => setShow4(true);

    const [show5, setShow5] = useState(false);

    const handleClose5 = () => setShow5(false);
    const handleShow5 = () => setShow5(true);

    const [show6, setShow6] = useState(false);

    const handleClose6 = () => setShow6(false);
    const handleShow6 = () => setShow6(true);

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [builsheetid, setBuildSheetId] = useState(null);
    const [buildsheetname, setBuildsheetName] = useState('');
    const [projectId, setProjectId] = useState(null);
    const [closePopup, setClosePopup] = useState('');

    const handleCloseConfirmation = () => setShowConfirmation(false);
    const handleShowConfirmation = () => setShowConfirmation(true);
    const [showConfirmation, setShowConfirmation] = useState(false);

    const [buildSheetStatus, setBuildSheetStatus] = useState(false);
    const [type, setType] = useState("");
    const [userdata, setUserdata] = useState('');
    const [makedata, setMakeData] = useState([]);
    const [selectoptiondata, setSelectOptionData] = useState(null);

    const [buildSheetData, setBuildSheetData] = useState({
        ClubHead: {
            make: '',
            model: '',
        },
        Loft: '',
        Lie: '',
        ClubHeadNotes: '',
        WeightPorts: {
            color: '',
            weight: ''
        },
        WeightPortNotes: '',
        Shaft: {
            make: '',
            model: '',
        },
        Weight: '',
        Flex: '',
        Length: '',
        ShaftWrap: '',
        ShaftNotes: '',
        CounterBalance: '',
        Grip: {
            brand: '',
            model: '',
            size: '',
            label: '',
        },
        GripNotes: '',
        Ferrule: '',
        CGSettings: '',
        AdapterSettings: '',
        LoftLie: '',
    });

    const deleteproject = () => {

        const data = {
            id: builsheetid,
            title: buildsheetname,
            user_id: userdata._id,
            fitter_name: userdata.firstname + " " + userdata.lastname,
            project_id: projectId
        }
        deletebuildsheetdata(data).then((res) => {
            if (res?.code === 200) {
                ondeleteChange(builsheetid);
                handleCloseConfirmation();
            } else {
                alert(res?.message);
            }
        }).catch((err) => {
            alert(err);
        })

    }

    // const handleChange = (e) => {
    //     const { name, value } = e.target;
    //     const keys = name.split('.');

    //     if (keys.length > 1) {
    //         setBuildSheetData((prevState) => {
    //             const nestedState = { ...prevState };
    //             let current = nestedState;
    //             for (let i = 0; i < keys.length - 1; i++) {
    //                 current = current[keys[i]];
    //             }
    //             current[keys[keys.length - 1]] = value;
    //             return nestedState;
    //         });
    //     } else {
    //         setBuildSheetData({
    //             ...buildSheetData,
    //             [name]: value
    //         });
    //     }
    // };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setBuildSheetData(prevState => updateNestedState(prevState, name, value));
    };

    const getsingledatabuilsheet = () => {
        getsinglebuilsheet({ id: builsheetid }).then((res) => {
            if (res?.code === 200) {
                const Data = res.data.data;
                console.log("Data", Data);
                setBuildSheetData(Data);
                setBuildSheetStatus(Data.update_status)
            } else {
                // alert(res?.message);
            }
        }).catch((err) => {
            alert(err);
        }).finally(() => {
            // handleShow2();
        });
    }

    useEffect(() => {
        if (builsheetid && type === "edit") {
            getsingledatabuilsheet();
        }
    }, [builsheetid]);

    const updateclub = () => {
        const data = {
            id: builsheetid,
            buildSheetData: buildSheetData
        }
        updatebuildsheetdata(data).then((res) => {
            if (res?.code === 200) {
                handleClose2();
                setBuildSheetId(null);
            } else {
                alert(res?.message);
            }
        }).catch((err) => {
            alert(err);
        })
    }

    useEffect(() => {
        const getCurrentUserdata = getCurrentUser();

        if (getCurrentUserdata && getCurrentUserdata.user) {
            setUserdata(getCurrentUserdata.user);
        } else {
            console.error("Current user data is null or undefined");
        }

    }, []);

    const [titleModel, settitleModel] = useState("")
    const [shaftdata, setShaftData] = useState([]);
    const [gripdata, setGripData] = useState([]);



    const handleShowBtn = (name) => {

        var showname = "";
        let parts = name.split(" ");
        if (parts.length > 1) {
            showname = parts[1];
        } else {
            showname = parts[0];
        }

        settitleModel(name);

        if (showname === "Driver" || showname === "Wood") {
            handleShow();
        }

        if (showname === "Hybrid") {
            handleShow3();
        }

        if (showname === "Iron" || showname === "Wedge" || showname === "PW") {
            handleShow4();
        }

        if (showname === "Putter") {
            handleShow6();
        }

        if (showname === "GW" || showname === "SW" || showname === "LW") {
            handleShow5();
        }
    };

    useEffect(() => {
        if (closePopup === "driver&Wood") {
            handleClose();
        }
        if (closePopup === "Hybrid") {
            handleClose3();

        }
        if (closePopup === "Iron&Wedge") {
            handleClose4();
        }
        if (closePopup === "Wedge") {
            handleClose5();
        }
        if (closePopup === "Putter") {
            handleClose6();
        }
        setClosePopup('');
        setBuildSheetId(null);
    }, [closePopup])

    const getmakedata = (id) => {
        const data = {
            type_id: id
        }
        getInventoryByTypeWithShaftAndGrip(data).then((response) => {
            if (!response.data.status) {
                console.log(response.data.message);
            } else {
                const data = response.data.data;
                console.log("data", data);
                setMakeData(data.makeData);
                setShaftData(data.shaftdata);
                setGripData(data.gripdata);
            }
        }
        ).catch((err) => {
            console.log(err);
        });
    }

    useEffect(() => {
        if (selectedOptions) {
            setSelectOptionData(selectedOptions);
        }
    }, [selectedOptions]);

    const [buttonNames, setButtonNames] = useState([
        { id: 1, name: "Driver" },
        { id: 2, name: "3 Wood" },
        { id: 2, name: "4 Wood" },
        { id: 2, name: "5 Wood" },
        { id: 2, name: "7 Wood" },
        { id: 2, name: "9 Wood" },
        { id: 3, name: "2 Hybrid" },
        { id: 3, name: "3 Hybrid" },
        { id: 3, name: "4 Hybrid" },
        { id: 3, name: "5 Hybrid" },
        { id: 3, name: "6 Hybrid" },
        { id: 3, name: "7 Hybrid" },
        { id: 3, name: "8 Hybrid" },
        { id: 4, name: "1 Iron" },
        { id: 4, name: "2 Iron" },
        { id: 4, name: "3 Iron" },
        { id: 4, name: "4 Iron" },
        { id: 4, name: "5 Iron" },
        { id: 4, name: "6 Iron" },
        { id: 4, name: "7 Iron" },
        { id: 4, name: "8 Iron" },
        { id: 4, name: "9 Iron" },
        { id: 5, name: "PW" },
        { id: 5, name: "GW" },
        { id: 5, name: "SW" },
        { id: 5, name: "LW" },
        { id: 6, name: "Putter" }
    ]);


    const buttonIndexMap = buttonNames.reduce((acc, button, index) => {
        acc[button.name.toLowerCase()] = index;
        return acc;
    }, {});

    // Filter and sort buildsheets
    const filteredAndSortedBuildsheets = buildsheets
        .filter(sheet => buttonIndexMap.hasOwnProperty(sheet.title.toLowerCase()))
        .sort((a, b) => {
            const aIndex = buttonIndexMap[a.title.toLowerCase()];
            const bIndex = buttonIndexMap[b.title.toLowerCase()];
            return aIndex - bIndex;
        });





    return (


        <>
            {
                allmodels ? (<>
                    <Modal size="lg" centered show={show2} onHide={() => { handleClose2(); setBuildSheetId(null); }} className="card-radius popup-modal-dark add_club_modal build_sheet_modal">
                        <Modal.Body className="bg_dark_black card-dark card-radius dark_modal_mobile">
                            <div className="close-modal">
                                <div className="custom-modal-header">
                                    <h3 className="text mb-5">{buildsheetname}</h3>
                                    <button type="button" className="btn-close" onClick={() => { handleClose2(); setBuildSheetId(null); }} aria-label="Close">
                                        <IoClose />
                                    </button>
                                </div>
                            </div>
                            <div className='modal-long-form'>
                                {/* <form className='modal-long-form-inner'> */}
                                <div className='row'>
                                    <div className='col-md-12'>
                                        <div className='form-group'>
                                            <div className='form-group-label'>
                                                <label className='form-label'>Club Head</label>
                                            </div>
                                            <div className='form-group-input mb-4'>
                                                <select name="ClubHead.make" value={buildSheetData?.ClubHead?.make || ""} onChange={handleChange} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                    <option selected>Make</option>
                                                    <option value="1">1 ft.</option>
                                                    <option value="2">2 ft.</option>
                                                    <option value="3">3 ft.</option>
                                                </select>
                                            </div>
                                            <div className='form-group-input'>
                                                <select name="ClubHead.model" value={buildSheetData?.ClubHead?.model || ""} onChange={handleChange} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                    <option selected>Model</option>
                                                    <option value="1">1 ft.</option>
                                                    <option value="2">2 ft.</option>
                                                    <option value="3">3 ft.</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-md-6'>
                                        <div className='form-group'>
                                            <div className='form-group-label'>
                                                <label className='form-label'>Loft</label>
                                            </div>
                                            <div className='form-group-input'>
                                                <select name="Loft" value={buildSheetData?.Loft || ""} onChange={handleChange} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                    <option selected>Loft</option>
                                                    <option value="1">1 ft.</option>
                                                    <option value="2">2 ft.</option>
                                                    <option value="3">3 ft.</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-md-6'>
                                        <div className='form-group'>
                                            <div className='form-group-label'>
                                                <label className='form-label'>Lie</label>
                                            </div>
                                            <div className='form-group-input'>
                                                <select name="Lie" value={buildSheetData?.Lie || ""} onChange={handleChange} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                    <option selected>Lie</option>
                                                    <option value="1">1 ft.</option>
                                                    <option value="2">2 ft.</option>
                                                    <option value="3">3 ft.</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-md-12'>
                                        <div className='form-group'>
                                            <div className='form-group-label'>
                                                <label className='form-label'>Club Head Notes</label>
                                            </div>
                                            <div className='form-group-input'>
                                                <textarea name="ClubHeadNotes" value={buildSheetData?.ClubHeadNotes || ""} onChange={handleChange} class="form-control dashboard-text-area" id="exampleFormControlTextarea1" rows="8" placeholder="Club head notes..."></textarea>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-md-12'>
                                        <div className='form-group'>
                                            <div className='form-group-label d-flex align-items-center justify-content-between'>
                                                <label className='form-label'>Weight Ports</label>
                                                <div className='form-group-check'>
                                                    <input type="checkbox" className="form-check-input" id="exampleCheck1" />
                                                </div>
                                            </div>
                                            <div className='row'>
                                                <div className='col-md-6'>
                                                    <div className='form-group-input'>
                                                        <select name="WeightPorts.color" value={buildSheetData?.WeightPorts?.color || ""} onChange={handleChange} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                            <option selected>Color</option>
                                                            <option value="1">1 ft.</option>
                                                            <option value="2">2 ft.</option>
                                                            <option value="3">3 ft.</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group-input'>
                                                        <select name="WeightPorts.weight" value={buildSheetData?.WeightPorts?.weight || ''} onChange={handleChange} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                            <option selected>Weight</option>
                                                            <option value="1">1 ft.</option>
                                                            <option value="2">2 ft.</option>
                                                            <option value="3">3 ft.</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-md-12'>
                                        <div className='form-group'>
                                            <div className='form-group-label'>
                                                <label className='form-label'>Weight Port Notes</label>
                                            </div>
                                            <div className='form-group-input'>
                                                <textarea name="WeightPortNotes" value={buildSheetData?.WeightPortNotes || ""} onChange={handleChange} class="form-control dashboard-text-area" id="exampleFormControlTextarea1" rows="8" placeholder="Weight port notes..."></textarea>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-md-12'>
                                        <div className='form-group'>
                                            <div className='form-group-label'>
                                                <label className='form-label'>Shaft</label>
                                            </div>
                                            <div className='form-group-input mb-4'>
                                                <select name="Shaft.make" value={buildSheetData?.Shaft?.make || ''} onChange={handleChange} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                    <option selected>Make</option>
                                                    <option value="1">1 ft.</option>
                                                    <option value="2">2 ft.</option>
                                                    <option value="3">3 ft.</option>
                                                </select>
                                            </div>
                                            <div className='form-group-input'>
                                                <select name="Shaft.model" value={buildSheetData?.Shaft?.model || ''} onChange={handleChange} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                    <option selected>Model</option>
                                                    <option value="1">1 ft.</option>
                                                    <option value="2">2 ft.</option>
                                                    <option value="3">3 ft.</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-md-4'>
                                        <div className='form-group'>
                                            <div className='form-group-label'>
                                                <label className='form-label'>Weight</label>
                                            </div>
                                            <div className='form-group-input'>
                                                <select name="Weight" value={buildSheetData?.Weight || ''} onChange={handleChange} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                    <option selected>Weight</option>
                                                    <option value="1">1 ft.</option>
                                                    <option value="2">2 ft.</option>
                                                    <option value="3">3 ft.</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-md-4'>
                                        <div className='form-group'>
                                            <div className='form-group-label'>
                                                <label className='form-label'>Flex</label>
                                            </div>
                                            <div className='form-group-input'>
                                                <select name="Flex" value={buildSheetData?.Flex || ''} onChange={handleChange} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                    <option selected>Flex</option>
                                                    <option value="1">1 ft.</option>
                                                    <option value="2">2 ft.</option>
                                                    <option value="3">3 ft.</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-md-4'>
                                        <div className='form-group'>
                                            <div className='form-group-label'>
                                                <label className='form-label'>Length</label>
                                            </div>
                                            <div className='form-group-input'>
                                                <select name="Length" value={buildSheetData?.Length || ''} onChange={handleChange} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                    <option selected>Length</option>
                                                    <option value="1">1 ft.</option>
                                                    <option value="2">2 ft.</option>
                                                    <option value="3">3 ft.</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-md-12'>
                                        <div className='form-group'>
                                            <div className='form-group-label d-flex align-items-center justify-content-between'>
                                                <label className='form-label'>Shaft Wrap</label>
                                                <div className='form-group-check'>
                                                    <input type="checkbox" className="form-check-input" id="exampleCheck1" />
                                                </div>
                                            </div>
                                            <div className='form-group-input'>
                                                <textarea name="ShaftWrap" value={buildSheetData?.ShaftWrap || ''} onChange={handleChange} class="form-control dashboard-text-area" id="exampleFormControlTextarea1" rows="8" placeholder="Shaft wrap notes..."></textarea>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-md-12'>
                                        <div className='form-group'>
                                            <div className='form-group-label d-flex align-items-center justify-content-between'>
                                                <label className='form-label'>Shaft Notes</label>
                                            </div>
                                            <div className='form-group-input'>
                                                <textarea name="ShaftNotes" value={buildSheetData?.ShaftNotes || ''} onChange={handleChange} class="form-control dashboard-text-area" id="exampleFormControlTextarea1" rows="8" placeholder="Shaft  notes..."></textarea>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-md-12'>
                                        <div className='form-group'>
                                            <div className='form-group-label'>
                                                <label className='form-label'>Counter Balance</label>
                                            </div>
                                            <div className='form-group-input'>
                                                <select name="CounterBalance" value={buildSheetData?.CounterBalance || ''} onChange={handleChange} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                    <option selected>Weight</option>
                                                    <option value="1">1 ft.</option>
                                                    <option value="2">2 ft.</option>
                                                    <option value="3">3 ft.</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-md-12'>
                                        <div className='form-group'>
                                            <div className='form-group-label'>
                                                <label className='form-label'>Grip</label>
                                            </div>
                                            <div className='row'>
                                                <div className='col-md-6'>
                                                    <div className='form-group-input mb-4'>
                                                        <select name="Grip.brand" value={buildSheetData?.Grip?.brand || ''} onChange={handleChange} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                            <option selected>Brand</option>
                                                            <option value="1">1 ft.</option>
                                                            <option value="2">2 ft.</option>
                                                            <option value="3">3 ft.</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group-input'>
                                                        <select name="Grip.model" value={buildSheetData?.Grip?.model || ''} onChange={handleChange} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                            <option selected>Model</option>
                                                            <option value="1">1 ft.</option>
                                                            <option value="2">2 ft.</option>
                                                            <option value="3">3 ft.</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className='col-md-12'>
                                                    <div className='form-group-input mb-4'>
                                                        <select name="Grip.size" value={buildSheetData?.Grip?.size || ''} onChange={handleChange} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                            <option selected>Size</option>
                                                            <option value="1">1 ft.</option>
                                                            <option value="2">2 ft.</option>
                                                            <option value="3">3 ft.</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className='col-md-12'>
                                                    <div className='form-group-input'>
                                                        <select name="Grip.label" value={buildSheetData?.Grip?.label || ''} onChange={handleChange} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                            <option selected>Label</option>
                                                            <option value="1">1 ft.</option>
                                                            <option value="2">2 ft.</option>
                                                            <option value="3">3 ft.</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-md-12'>
                                        <div className='form-group'>
                                            <div className='form-group-label d-flex align-items-center justify-content-between'>
                                                <label className='form-label'>Grip Notes</label>
                                            </div>
                                            <div className='form-group-input'>
                                                <textarea name="GripNotes" value={buildSheetData?.GripNotes || ''} onChange={handleChange} class="form-control dashboard-text-area" id="exampleFormControlTextarea1" rows="8" placeholder="Grip notes..."></textarea>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-md-12'>
                                        <div className='form-group'>
                                            <div className='form-group-label d-flex align-items-center justify-content-between'>
                                                <label className='form-label'>Ferrule</label>
                                            </div>
                                            <div className='form-group-input'>
                                                <textarea name="Ferrule" value={buildSheetData?.Ferrule || " "} onChange={handleChange} class="form-control dashboard-text-area" id="exampleFormControlTextarea1" rows="8" placeholder="Ferrule notes..."></textarea>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className='row'>
                                    <div className='full-width-btn'>
                                        <>
                                            {buildSheetStatus === "true" ? (
                                                <button className="btn btn-primary btn-create" onClick={updateclub}>
                                                    Update Club
                                                </button>
                                            ) : (
                                                <button className="btn btn-primary btn-create" onClick={updateclub}>
                                                    Add Club
                                                </button>
                                            )}
                                        </>
                                    </div>
                                </div>
                                {/* </form> */}
                            </div>
                        </Modal.Body>
                    </Modal>

                    <Modal
                        show={showConfirmation}
                        onHide={handleCloseConfirmation}
                        centered
                        id="success_tic"
                        className='model-thank-you'
                    >
                        <Modal.Body>
                            <div className="logo-modal mb-4 text-center">
                                <img src={require('../../assets/images/logo_text.png')} alt="logo" />
                            </div>
                            <div className="confirmation-content text-center">
                                <h4>Are you sure you want to remove this club from the Build Sheet?</h4>
                                <div className="confirmation-buttons mt-4">
                                    <Button variant="danger" onClick={deleteproject} >
                                        Yes
                                    </Button>
                                    {' '}
                                    <Button variant="secondary" onClick={() => {
                                        handleCloseConfirmation();
                                        setBuildSheetId(null);
                                    }}>
                                        No
                                    </Button>
                                </div>
                            </div>
                        </Modal.Body>
                    </Modal>

                    {/* Driver + Wood Modal Start Here */}
                    <Modal fullscreen={true} show={show} id="success_tic" centered className="card-radius popup-modal-dark add_club_modal unique m-0">
                        <Modal.Body className="bg_dark_black card-dark card-radius dark_modal_mobile">
                            <div className="close-modal">
                                <div className="custom-modal-header">
                                    <h3 className="text mb-5">{titleModel}</h3>
                                    <button type="button" className="btn-close" onClick={handleClose} aria-label="Close">
                                        <IoClose />
                                    </button>
                                </div>
                            </div>
                            <div className="modal-long-form">
                                <DriverWood selecteddata={buildSheetData} ondeleteChange={(closetstatus) => setClosePopup(closetstatus)} makedata={makedata} selectoptiondata={selectoptiondata} shaftdata={shaftdata} gripdata={gripdata} title={titleModel} allmodels={allmodels} remortFittingFormData={remortFittingFormData} />
                            </div>
                        </Modal.Body>
                    </Modal>
                    {/* Driver + Wood Modal End Here  */}

                    {/* Hybrid Modal Start Here */}
                    <Modal size="lg" show={show3} id="success_tic" centered className="card-radius popup-modal-dark add_club_modal build_sheet_modal unique m-0">
                        <Modal.Body className="bg_dark_black card-dark card-radius dark_modal_mobile">
                            <div className="close-modal">
                                <div className="custom-modal-header">
                                    <h3 className="text mb-5">{titleModel}</h3>
                                    <button type="button" className="btn-close" onClick={handleClose3} aria-label="Close">
                                        <IoClose />
                                    </button>
                                </div>
                            </div>
                            <div className="modal-long-form">
                                <Hybrid selecteddata={buildSheetData} ondeleteChange={(closetstatus) => setClosePopup(closetstatus)} makedata={makedata} selectoptiondata={selectoptiondata} shaftdata={shaftdata} gripdata={gripdata} title={titleModel} allmodels={allmodels} remortFittingFormData={remortFittingFormData} />
                            </div>
                        </Modal.Body>
                    </Modal>
                    {/* Hybrid Modal End Here  */}

                    {/* Iron + Wedge Start Here */}
                    <Modal size="lg" show={show4} id="success_tic" centered className="card-radius popup-modal-dark add_club_modal build_sheet_modal unique m-0">
                        <Modal.Body className="bg_dark_black card-dark card-radius dark_modal_mobile">
                            <div className="close-modal">
                                <div className="custom-modal-header">
                                    <h3 className="text mb-5">{titleModel}</h3>
                                    <button type="button" className="btn-close" onClick={handleClose4} aria-label="Close">
                                        <IoClose />
                                    </button>
                                </div>
                            </div>
                            <div className="modal-long-form">
                                <IronWedge selecteddata={buildSheetData} ondeleteChange={(closetstatus) => setClosePopup(closetstatus)} makedata={makedata} selectoptiondata={selectoptiondata} shaftdata={shaftdata} gripdata={gripdata} title={titleModel} allmodels={allmodels} remortFittingFormData={remortFittingFormData} />
                            </div>
                        </Modal.Body>
                    </Modal>
                    {/* Iron + Wedge End Here  */}

                    {/* Wedge Start Here */}
                    <Modal size="lg" show={show5} id="success_tic" centered className="card-radius popup-modal-dark add_club_modal build_sheet_modal unique m-0">
                        <Modal.Body className="bg_dark_black card-dark card-radius dark_modal_mobile">
                            <div className="close-modal">
                                <div className="custom-modal-header">
                                    <h3 className="text mb-5">{titleModel}</h3>
                                    <button type="button" className="btn-close" onClick={handleClose5} aria-label="Close">
                                        <IoClose />
                                    </button>
                                </div>
                            </div>
                            <div className="modal-long-form">
                                <Wedge selecteddata={buildSheetData} ondeleteChange={(closetstatus) => setClosePopup(closetstatus)} makedata={makedata} selectoptiondata={selectoptiondata} shaftdata={shaftdata} gripdata={gripdata} title={titleModel} allmodels={allmodels} remortFittingFormData={remortFittingFormData} />
                            </div>
                        </Modal.Body>
                    </Modal>
                    {/* Wedge End Here  */}

                    {/* Putter Start Here */}
                    <Modal size="lg" show={show6} id="success_tic" centered className="card-radius popup-modal-dark add_club_modal build_sheet_modal unique m-0">
                        <Modal.Body className="bg_dark_black card-dark card-radius dark_modal_mobile">
                            <div className="close-modal">
                                <div className="custom-modal-header">
                                    <h3 className="text mb-5">{titleModel}</h3>
                                    <button type="button" className="btn-close" onClick={handleClose6} aria-label="Close">
                                        <IoClose />
                                    </button>
                                </div>
                            </div>
                            <div className="modal-long-form">
                                <Putter selecteddata={buildSheetData} ondeleteChange={(closetstatus) => setClosePopup(closetstatus)} makedata={makedata} selectoptiondata={selectoptiondata} shaftdata={shaftdata} gripdata={gripdata} title={titleModel} allmodels={allmodels} remortFittingFormData={remortFittingFormData} />
                            </div>
                        </Modal.Body>
                    </Modal>
                    {/* Putter End Here  */}

                    <div className="accordion-section">
                        <>
                            {
                                filteredAndSortedBuildsheets.length === 0 ? (
                                    <div className="tab-box-section notes-tab mt-4">
                                        <div className='no-data-img'>
                                            <img src={require("../../assets/images/logo_text.png")} alt="" />
                                        </div>
                                        <div className="no-data-text">
                                            <h3>No data Found</h3>
                                        </div>
                                    </div>
                                )
                                    :
                                    filteredAndSortedBuildsheets.map((item, i) => {
                                        return (
                                            <>
                                                <div className="build_number_box club-fitting-card">
                                                    <div className="build_number_box_inner">
                                                        <div className="build_title">
                                                            {item.title}
                                                        </div>
                                                        <div className="d-flex align-items-center">
                                                            <button className="transparent-btn" disabled={selectoptiondata !== 'Unassigned'} onClick={(e) => {
                                                                handleShowConfirmation()
                                                                setBuildSheetId(item._id)
                                                                setBuildsheetName(item.title);
                                                                setProjectId(item.project_id);
                                                                setType("delete");
                                                            }}>
                                                                <div className="gab_icon ">
                                                                    <IoClose />
                                                                </div>
                                                            </button>
                                                            <button className="transparent-btn"
                                                                onClick={(e) => {
                                                                    setBuildSheetId(item._id);
                                                                    setBuildsheetName(item.title);
                                                                    handleShowBtn(item.title);
                                                                    setType("edit");
                                                                    getmakedata(item.type_id);
                                                                    // getsingledatabuilsheet();
                                                                }}>
                                                                <div className="collapsed">
                                                                    <div className="gab_icon" >
                                                                        <IoEye />
                                                                    </div>
                                                                </div>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        )
                                    }
                                    )
                            }
                        </>

                    </div>
                    <style>
                        {
                            `
                                .unique .modal-dialog{
                                    max-width: 100% !important;
                                     width: 100% !important;
                                }
                                `
                        }
                    </style>
                </>) : (<></>)
            }

        </>





    );
}

export default BuildAccordion;